import I18N_FORMAT_MAP from '@rover/constants/src/i18n/i18nFormatMap.constants';
import { DEFAULT_LOCALE, normalizeLocale } from '@rover/constants/src/i18n/locale';

const getLocalizedFormatContextless = (format: string, locale?: string): string => {
  const localizedFormats = I18N_FORMAT_MAP[normalizeLocale(locale) ?? DEFAULT_LOCALE];
  return localizedFormats[format] || I18N_FORMAT_MAP[DEFAULT_LOCALE][format] || format;
};

export default getLocalizedFormatContextless;
